import { graphQlClient } from '@config/graphqlClient';
import {
  getSelfRequest,
  getUserOrganizationsRequest,
} from '@models/user.model';
import UserGraphQL from '@graphql/user.queries';

export const getSelf = async (): Promise<getSelfRequest> => {
  return await graphQlClient.request(UserGraphQL.queries.getSelf);
};

export const getUserOrganizations =
  async (): Promise<getUserOrganizationsRequest> => {
    return await graphQlClient.request<getUserOrganizationsRequest>(
      UserGraphQL.queries.getUserOrganizations,
    );
  };
